<template>
  <v-app>
    <confirmDlg ref="confirm"></confirmDlg>
    <messageDlg ref="message"></messageDlg>
    <loaderDlg ref="loader"></loaderDlg>
    <RwNavigationDrawer v-if="signedIn" v-model="drawerMenu">
      <template v-slot:menu-content>
        <Menu />
      </template>
    </RwNavigationDrawer>
    <RwHeader v-if="signedIn">
      <template v-slot:bar-nav-icon>
        <v-app-bar-nav-icon
          @click.stop="drawerMenu = !drawerMenu"
        ></v-app-bar-nav-icon>
        <img :src="logoFilename" />
        <v-spacer></v-spacer>
        <template>
          <div class="text-center">
            <v-menu :close-on-content-click="false" :nudge-width="150" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="grey darken-2" dark v-bind="attrs" v-on="on">
                  {{ $keycloak.tokenParsed.name }}
                </v-btn>
              </template>

              <v-list>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>fa-user-circle</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $keycloak.tokenParsed.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $keycloak.tokenParsed.preferred_username }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ $t("users.agency") }} :
                      {{ $keycloak.tokenParsed.agency }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>

              <ChangePassword ref="changePsw"></ChangePassword>
            </v-menu>
          </div>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="signout()">
              <v-icon>mdi-export</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("global.disconnect") }}</span>
        </v-tooltip>
      </template>
    </RwHeader>
    <v-main>
      <router-view />
    </v-main>
    <RwFooter />
  </v-app>
</template>

<script>
import ChangePassword from "@/components/ChangePassword.vue";
import RwNavigationDrawer from "@/components/NavigationDrawer.vue";
import RwHeader from "@/components/Header.vue";
import RwFooter from "@/components/Footer.vue";
import confirmDlg from "@/components/ConfirmDlg.vue";
import messageDlg from "@/components/MessageDlg.vue";
import loaderDlg from "@/components/Loader.vue";
import Menu from "./views/Menu.vue";
import Vue from "vue";
import * as themesVuetify from "./plugins/themes.js";

require("@/css/application.css");

export default {
  name: "App",
  components: {
    ChangePassword,
    RwNavigationDrawer,
    RwHeader,
    RwFooter,
    confirmDlg,
    messageDlg,
    loaderDlg,
    Menu
  },
  data: () => ({
    drawerMenu: false,
    signedIn: false,
    organization: "alerce",
    right: null
  }),
  methods: {
    signout() {
      Vue.$keycloak.logout();
    },
    async refreshActiveUser() {
      try {
        if (this.$profileLoaded) {
          this.organization = Vue.$keycloak.tokenParsed.tenant;
          this.organizationStyles(this.organization);
          this.signedIn = true;
        }
      } catch (err) {
        this.signedIn = false;
      }
    },
    organizationStyles(value) {
      if (value === "XPO") {
        this.$vuetify.theme.themes.light = themesVuetify.xpo;
      } else {
        this.$vuetify.theme.themes.light = themesVuetify.alerce;
      }
    }
  },
  watch: {
    // everytime a route is changed refresh the activeUser
    $route: "refreshActiveUser"
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$message = this.$refs.message.open;
    this.$root.$loading = this.$refs.loader.show;
    this.$root.$loaded = this.$refs.loader.hide;
  },
  async beforeCreate() {
    await this.$getProfilesPermissions();
    await this.$getUserAdmin();
    this.refreshActiveUser();
  },
  computed: {
    logoFilename() {
      try {
        return require("@/assets/logo-" + this.organization + ".svg");
      } catch (error) {
        return "";
      }
    }
  }
};
</script>
